import editorFormCtlType from './editorFormCtlType';

export default {
  ...editorFormCtlType,
  EnumRel: 'EnumRel',
  xmFileUpload: 'xmInput',
  xmSwitch: 'xmSelect',
  'PriceInput': 'xmPriceRange',
  FloatNumber: 'xmNumberRange',
  InputNumber: 'xmNumberRange',
  'Switch': 'xmSelect',
  xmSubTable: 'xmInput',
  xmIconSelect: 'xmInput',
  Image: 'xmInput',
  'Radio.Group': 'xmSelect',
  Radio: 'xmSelect',
  xmRadioGroup: 'xmSelect',
  'TimePicker': 'xmTimePickerRange',
  'Checkbox.Group': 'xmSelect',
  'Input.TextArea': 'xmInput',
  DatePicker__withTime: 'xmDateRange',
  'DatePicker__month': 'xmMonthRange',
  'DatePicker__year': 'xmYearRange',
  recordStatus: 'xmSelect',
  'UserSelect': 'xmUserSelect',
  xmUserSelect: 'UserSelect',
  'xmRelForm': 'xmRelForm',
  xmComputeField: 'xmInput',
  xmReadOnly: 'xmInput',
  xmEditor: 'xmInput',
  'HtmlEditor': 'xmInput',
  xmTagContent: 'xmDataSelect',
}
